import r from "../managers/braze-instance.js";
import ie from "./feed-provider-factory.js";
export function subscribeToFeedUpdates(e) {
  if (r.rr()) return ie.m().Fs(e);
}
